<div class="container">
  <!-- Dropdown Filters -->
  <div class="text-center">
    <strong class="mainHeading">Dumpyard</strong>
  </div>
  <div class="row mt-3 justify-content-around">
    <!-- City Filter -->
    <div class="col-md-3">
      <label for="selectCity" class="form-label">Select City</label>
      <select
        id="selectCity"
        class="form-select"
        [(ngModel)]="selectedCity"
        (change)="onCityChange($event)"
      >
        <option value="all">All</option>
        <option *ngFor="let city of cityList" [value]="city.id">
          {{ city.cityName }}
        </option>
      </select>
    </div>

    <!-- Zone Filter -->
    <div class="col-md-3">
      <label for="selectZone" class="form-label">Select Zone</label>
      <select
        id="selectZone"
        class="form-select"
        [(ngModel)]="selectedZone"
        (change)="filterGrid()"
        [disabled]="zoneList?.length === 0"
      >
        <option value="all">All</option>
        <option *ngFor="let zone of zoneList" [value]="zone.zoneId">
          {{ zone.zoneName }}
        </option>
      </select>
    </div>

    <!-- Status Filter -->
    <div class="col-md-3">
      <label for="selectStatus" class="form-label">Select Status</label>
      <select
        id="selectStatus"
        class="form-select"
        [(ngModel)]="selectedStatus"
        (change)="filterGrid()"
      >
        <option value="all">All</option>
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>
    </div>
  </div>

  <div class="row d-flex justify-content-around">
    <div class="col-md-3">
      <div
        class="card shadow-sm dashboard-card"
        style="background-color: #f8ecc8"
      >
        <div
          class="card-body d-flex flex-column justify-content-between"
          style="height: 150px"
        >
          <div class="d-flex white">
            <i
              class="bi bi-person-lines-fill fa-2x me-3 empPermission"
              style="color: #ad870c !important"
            ></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center empPermission">
                {{ cardData?.overallUsersCount }}
              </h3>
            </div>
          </div>
          <div class="text-center">
            <p class="card-text empPermission">Total Users</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 ms-2">
      <div class="card shadow-sm dashboard-card" style="background: #dcffddf7">
        <div
          class="card-body d-flex flex-column justify-content-between"
          style="height: 150px"
        >
          <div class="d-flex white">
            <i
              class="bi bi-person-check fa-2x me-3 empPresent"
              style="color: #2d702f !important"
            ></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center empPresent">
                {{ cardData?.activeUsersCount }}
              </h3>
            </div>
          </div>
          <div class="text-center">
            <p class="card-text empPresent">Active Users</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3 ms-2">
      <div
        class="card shadow-sm dashboard-card"
        style="background-color: #f8d7e5"
      >
        <div
          class="card-body d-flex flex-column justify-content-between"
          style="height: 150px"
        >
          <div class="d-flex white">
            <i
              class="bi bi-person-slash fa-2x me-3 totalEmployees"
              style="color: #9b1b30 !important"
            ></i>
            <div class="ms-auto text-end">
              <h3 class="card-title mb-0 text-center totalEmployees">
                {{ cardData?.inActiveUserCount }}
              </h3>
            </div>
          </div>
          <div class="text-center">
            <p class="card-text totalEmployees">Inactive Users</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Data Grid -->
  <div class="card shadow-lg p-3">
    <div class="d-flex align-items-center">
      <div class="d-flex">
        <button
          class="btn btn-outline-secondary"
          type="button"
          ngbTooltip="Export"
          (click)="exportToExcel()"
        >
          <span><i class="bi bi-box-arrow-up me-2"></i></span>
          Export
        </button>
        <button
          class="btn btn-outline-secondary ms-2"
          type="button"
          ngbTooltip="Print"
          (click)="exportToPDF()"
        >
          <span><i class="bi bi-printer me-2"></i></span>
          Print
        </button>
        <button
          class="btn btn-outline-secondary ms-2"
          type="button"
          (click)="clearFilter()"
          ngbTooltip="Clear Filter"
        >
          <span><i class="bi bi-x-circle me-2"></i></span>
          Clear Filter
        </button>
      </div>
      <!-- <div class="ms-auto col-md-3 col-sm-6">
          <input type="text" class="form-control" placeholder="Search..." (input)="onSearch($event)">
        </div> -->
    </div>
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>
              Dumpyard Name
            </th>
            <th>Mobile No</th>
            <th>City</th>
            <th>Zone</th>
            <th>Date Registered</th>
            <th>CR Number</th>
            <th>VAT Number</th>
            <th>Is Active</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <!-- Display users data -->
          <tr *ngFor="let user of pagedData; let i = index">
            <td>{{ user.companyName }}</td>
            <td>{{ user.phNo }}</td>
            <td>{{ user.cityName }}</td>
            <td>{{ user.zoneName }}</td>
            <td>{{ user.createdDate | date : "dd MMM yyyy" }}</td>
            <td>{{ user.crNumber }}</td>
            <td>{{ user.vatNumber }}</td>
            <td class="text-center">
              <p
                [ngClass]="{
                  'text-success': user.isActive === true,
                  'text-danger': user.isActive === false
                }"
              >
                {{ getStatus(user.isActive) }}
              </p>
            </td>

            <td
              (click)="
                openDownloadDocumentsModal(user.userId, downloadDocumentsModal)
              "
            >
              <i class="ms-3 fas fa-download"></i>
            </td>
          </tr>

          <!-- Display No Data Found if filteredUsers is empty -->
          <tr *ngIf="dumpyardData?.length === 0">
            <td
              colspan="10"
              class="text-center"
              style="color: black !important"
            >
              No Data Found
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="filteredData?.length > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="filteredData?.length"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>

      <!-- Entries Message Aligned to the End -->
      <div *ngIf="filteredData?.length > 0" class="text-muted mb-3">
        <strong>
          Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > filteredData?.length
              ? filteredData?.length
              : page * pageSize
          }}
          of {{ filteredData?.length }} entries
        </strong>
      </div>
    </div>
  </div>

  <!-- Change Status Modal -->
  <ng-template #confirmModal let-modal>
    <div class="modal-header custom-modal-header">
      <h2 class="modal-title mt-2">Change Status</h2>
      <button
        type="button"
        class="btn-close"
        style="background-color: white !important"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>
    <div class="modal-body">
      <p>
        Do you want to change the status to
        <strong>{{
          currentCityForStatusChange?.isActive === true ? "Inactive" : "Active"
        }}</strong
        >?
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="changeCityStatus(modal)">
        Confirm
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancel
      </button>
    </div>
  </ng-template>
</div>

<ng-template #downloadDocumentsModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Download CR/VAT</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal">
    <p>Choose the document type:</p>

    <button
      type="button"
      class="btn btn-primary mt-3 mb-2"
      (click)="downloadCrVatDocument('CR')"
    >
      Download CR
    </button>
    &nbsp;
    <button
      type="button"
      class="btn btn-primary mt-3 mb-2"
      (click)="downloadCrVatDocument('VAT')"
    >
      Download VAT
    </button>
  </div>
</ng-template>

<ngx-spinner
  bdColor="rgba(0,0,0,0.1)"
  color="#8E0E00"
  size="default"
  type="ball-clip-rotate"
></ngx-spinner>
